<ng-template #treatmentCell let-row="row">
  <div class="treatments-cell">
    <div class="treatment-box gbm-box">
      <div class="treatment-count">{{ row.numberOfGbmTreatments }}</div>
    </div>
    <div class="treatment-box fertilization-box">
      <div class="treatment-count">{{ row.numberOfFertilizationTreatments }}</div>
    </div>
  </div>
</ng-template>

<ng-template #greenManureAction let-row="row">
  @if (canOpenGreenManure()) {
    <button
      type="button"
      mat-stroked-button
      class="green-manure-button"
      [attr.aria-label]="'greenManure.open' | translate"
      [matTooltip]="'greenManure.open' | translate"
      data-test="open-green-manure"
      (click)="$event.stopPropagation(); openGreenManure(row)"
    >
      <mat-icon>emoji_nature</mat-icon>
    </button>
  }
</ng-template>

<agr-summary-card [title]="'cropFieldsOverview' | translate" class="list-summary-card" [actions]="(actions$ | async)!">
  <ng-container customActions>
    @if (!isCropYearReadOnly() && (showOrderButton$ | async)) {
      <agr-dropdown-button
        [options]="(orderButtonOptions$ | async) ?? []"
        buttonText="{{ 'report.toOrder' | translate }}"
        data-test="order-advice-report-button"
      />
    }
    @if (companySettings$ | async; as settings) {
      @if (settings?.automaticAdvice) {
        <button mat-flat-button class="crops-view-button" (click)="navigateAddCropsView()" color="primary">
          <mat-icon class="spacing--margin-half-right">edit</mat-icon>
          {{ 'addCrops' | translate }}
        </button>
      }
    }
  </ng-container>

  @if (hasIncompleteAdvicePlan$ | async) {
    <div class="notification notification-info">
      <mat-icon>information</mat-icon>
      <span class="text--black">
        {{ 'cropWithoutAdviceInformation' | translate }}
      </span>
    </div>
  }

  @if (warningInfo$ | async; as warnings) {
    @for (warning of warnings; track warning.messageKey) {
      <div class="notification notification-warning">
        <mat-icon>warning</mat-icon>
        {{ warning.messageKey | translate }}
      </div>
    }
  }

  @if (cropFieldsTableConfig(); as cropFieldsTableConfig) {
    <agr-table [config]="cropFieldsTableConfig"></agr-table>
  }
</agr-summary-card>
